import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.536 6.264a.9.9 0 0 0-1.272 1.272l8.663 8.664H8.1a.9.9 0 1 0 0 1.8h9a.897.897 0 0 0 .9-.9v-9a.9.9 0 1 0-1.8 0v6.827z"
    }, null, -1)
  ])))
}
export default { render: render }